/* SaGó — oculta el header al bajar y lo muestra al subir.
   Extraído de sections/header.liquid (bloque <script> inline).
   Se carga con defer: el DOM ya existe cuando se ejecuta.

   SAGÓ, 14/10/2026 · No se oculta mientras haya algo abierto en él (un desplegable del menú o la búsqueda): el
   panel cuelga de la cabecera y, al subir con ella, se quedaba solo y sin llegar abajo. */

let lastScroll = 0;
const header = document.querySelector('.custom-header2026');
const scrollThreshold = 80;

window.addEventListener('scroll', () => {

  const currentScroll = window.pageYOffset;

  if (currentScroll > lastScroll && currentScroll > scrollThreshold && !header.querySelector('details[open]')) {
    // scroll hacia abajo → ocultar
    header.style.transform = "translateY(-100%)";
  } else {
    // scroll hacia arriba → mostrar
    header.style.transform = "translateY(0)";
  }

  lastScroll = currentScroll;

});

/* SaGó · menú propio del header (E5) — cerrar el desplegable con Escape.

   El resto del comportamiento no necesita JavaScript nuevo: el marcado es
   <details> dentro de <header-menu>, que es el custom element que Dawn ya carga
   en todas las páginas (assets/details-disclosure.js). De ahí sale abrir y
   cerrar al pulsar, y cerrar al salir el foco.

   Lo único que no trae es Escape, y sin eso el desplegable es una trampa para
   quien navega con teclado: se abre y no hay forma de cerrarlo sin tabular
   hasta el final. Se engancha en el documento y no por menú porque el marcado
   sólo existe cuando el ajuste está encendido. */
document.addEventListener('keydown', (evento) => {
  if (evento.key !== 'Escape') return;

  document
    .querySelectorAll('.custom-header2026 .sago-menu2026 details[open]')
    .forEach((desplegable) => {
      desplegable.removeAttribute('open');
      // Devolver el foco al <summary>: si se queda dentro de lo que se acaba
      // de cerrar, el navegador lo manda al principio de la página.
      desplegable.querySelector('summary')?.focus();
    });
});

/* SAGÓ, 13/10/2026 · menú propio — con ratón, los desplegables se abren al pasar por encima (como hacía Globo).
   Con teclado o con el dedo siguen abriéndose al pulsar, que es lo que ya hace <details>.

   Al salir se espera un momento antes de cerrar: el panel está en el borde izquierdo y hay que dar tiempo a
   llegar hasta él desde el elemento del menú. Entrar en otro elemento cierra el anterior al instante.

   Con ratón, pulsar sobre el título lleva a su colección (`data-enlace`, la misma que su «Ver todo»; con Ctrl o
   Cmd, en otra pestaña): el desplegable ya está abierto por estar encima (14/10/2026). `evento.detail` vale 0
   cuando el «clic» llega del teclado: ese abre y cierra, como siempre. */
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  const desplegables = document.querySelectorAll('.custom-header2026 .sago-menu2026 details');
  let cierre;

  desplegables.forEach((desplegable) => {
    const item = desplegable.closest('.sago-menu2026__item--padre');

    item.addEventListener('mouseenter', () => {
      clearTimeout(cierre);
      desplegables.forEach((otro) => otro.toggleAttribute('open', otro === desplegable));
    });
    item.addEventListener('mouseleave', () => {
      cierre = setTimeout(() => desplegable.removeAttribute('open'), 400);
    });
    const titulo = desplegable.querySelector('summary');
    titulo.addEventListener('click', (evento) => {
      if (evento.detail === 0) return;
      evento.preventDefault();
      const enlace = titulo.dataset.enlace;
      if (!enlace) return;
      if (evento.ctrlKey || evento.metaKey) {
        window.open(enlace, '_blank');
      } else {
        window.location.href = enlace;
      }
    });
  });
}

/* SAGÓ, 29/10/2026 · La cesta de la cabecera de móvil, al añadir (Marca/Cesta de la lista de SaGó: «el número no se
   actualiza en móvil al añadir»).

   Hay dos cestas en la página: la de la cabecera de escritorio (#cart-icon-bubble) y la de la de móvil
   (#cart-icon-bubble-mobile, sections/sago-header.liquid). Al añadir, Dawn pide la sección `cart-icon-bubble` y
   reescribe SOLO la primera, que de 980 px para abajo está escondida; la de móvil se quedaba como estaba. Y la que
   pinta el número de calendar-handler.js (pintarContadores) solo cambia el texto de burbujas que ya existen: con el
   carrito vacío la cesta no lleva burbuja (snippets/sago-cesta.liquid), así que el primer producto no se veía nunca.

   Se vigila la de escritorio y, cuando Dawn la reescribe, se copia su contenido a la de móvil, el mismo marcado.
   Sin bucle: el observador mira solo a los hijos directos de la cesta de escritorio (`childList`, sin `subtree` ni
   atributos) y escribe en OTRA, la de móvil, que nadie mira; el cambio de texto de pintarContadores no lo despierta.
   En reposo no hace nada, ni peticiones. Idempotente: si el script se carga dos veces (el editor de temas recarga la
   sección), solo engancha una vez por elemento. */
(function sincronizarCestaMovil() {
  const escritorio = document.getElementById('cart-icon-bubble');
  const movil = document.getElementById('cart-icon-bubble-mobile');
  if (!escritorio || !movil || escritorio.dataset.sagoSincroniza) return;
  escritorio.dataset.sagoSincroniza = 'true';

  const copiar = () => {
    if (movil.innerHTML !== escritorio.innerHTML) movil.innerHTML = escritorio.innerHTML;
  };
  new MutationObserver(copiar).observe(escritorio, { childList: true });
})();
